import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import StoreProductItem from "../ecommerce/store/StoreProductItem";
import { Product } from "../../data/ecommerce/storeCatalog";
import { getProductsofProvider } from "../../api";
import { getSubCategories } from "../../helpers/utils";
import { useProviderStore } from "../../store/providerStore";
import areaMontaje from '../../assets/img/providers/AreaMontaje2.webp';

interface EcomTiendaProps {
  searchTerm: string;
  providerId: number;
}

const EcomTienda: React.FC<EcomTiendaProps> = ({ searchTerm, providerId }) => {
  const location = useLocation();
  const { products, setProducts } = useProviderStore();
  const { sections, setSections } = useProviderStore();

  // Smooth scroll to a hashed section after render
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const id = location.hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    }

    if (providerId) {
      fetchListOfProducts();
    }
  }, [location, providerId]);

  async function fetchListOfProducts() {
    const listofProduct = await getProductsofProvider(Number(providerId));
    setProducts(listofProduct);
    getSections(listofProduct);
  }

  function getSections(products: Product[]) {
    const sections = products.map((x) => x.tagIds[0]);
    const uniqueSections = [...new Set(sections)];
    const tempCategories = getSubCategories(uniqueSections);
    const categoriesArray = uniqueSections.map((category, index) => ({
      tagId: category,
      name: tempCategories[index],
    }));
    setSections(categoriesArray);
  }

  // Filter products based on searchTerm
  let filteredProducts = products;
  if (searchTerm?.length >= 3 && products) {
    const lowerSearch = searchTerm.toLowerCase();
    filteredProducts = products.filter((product) =>
      product.name.toLowerCase().includes(lowerSearch) ||
      product.description.toLowerCase().includes(lowerSearch)
    );
  }

  // Render individual section with products
  const renderSection = (section: (typeof sections)[0], sectionIndex: number) => {
    const sectionProducts = filteredProducts?.filter(
      (product) => product.tagIds[0] === section.tagId,
    ) || [];

    if (sectionProducts.length === 0) return null;

    const productsWithImages = sectionProducts.filter(
      (product) => product.cover?.imageId,
    );

    return (
      <div
        key={`${section.tagId}-${sectionIndex}`}
        id={`${section.tagId}`}
        style={{ height: "auto", paddingTop: "10px" }}
      >
        <div className="section-bg">
          <div style={{ color: "#525B75" }} className="fw-bold fs-7">
            {section.name} ({sectionProducts.length})
          </div>
        </div>

        <Row className="pt-4">
          {productsWithImages.map((product) => (
            <Col key={product.id} xs={12} sm={6} md={4} lg={3}>
              <StoreProductItem
                id={product.id}
                imageId={product.cover.imageId}
                name={product.name}
                description={product.description}
                descriptionTags={product.hashtags}
                unitPrice={product.unitPrice}
                unitType={product.unitType || "piece"}
              />
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  // Show empty state when no products
  if (!products || products.length === 0) {
    return (
      <div className="bg-soft">
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <img 
            src={areaMontaje}
            alt="areaMontaje"
            style={{ maxWidth: "50%", height: "auto" }}
          />

           <p style={{fontWeight: 700, paddingTop: 25, fontSize: 20, marginBottom:0}}>¡Ya casi está listo!</p>
        <p> Estamos preparando el catálogo para que puedas ver lo que tenemos para tu evento.</p>
        </div>
      </div>
    );
  }

  // Show products
  return (
    <div className="bg-soft">
      {sections.map((section, sectionIndex) =>
        renderSection(section, sectionIndex),
      )}
    </div>
  );
};

export default EcomTienda;
